'use client';

import { c as _c } from "react/compiler-runtime";
import { faX } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@uzh-bf/design-system';
import { useTranslations } from 'next-intl';
import { mutate } from 'swr';
import useSWRMutation from 'swr/mutation';
import { bookmarkBlock } from '~/app/actions/unitProgress.server';
import { CACHE_KEYS } from '~/lib/cache';
import { useAuthToken } from '~/lib/hooks';
interface BookmarkRemovalButtonProps {
  courseId: number;
  moduleId: number;
  unitId: number;
  blockIdentifier: string;
}
function BookmarkRemovalButton(t0) {
  const $ = _c(18);
  const {
    courseId,
    moduleId,
    unitId,
    blockIdentifier
  } = t0;
  const t = useTranslations();
  const jwt = useAuthToken();
  let t1;
  if ($[0] !== courseId) {
    t1 = {
      onSuccess: () => {
        mutate(key => key?.includes(CACHE_KEYS.BOOKMARK({
          courseId
        })));
      }
    };
    $[0] = courseId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    trigger,
    isMutating
  } = useSWRMutation("bookmarkBlock", bookmarkBlock, t1);
  let t2;
  if ($[2] !== blockIdentifier || $[3] !== courseId || $[4] !== jwt || $[5] !== moduleId || $[6] !== trigger || $[7] !== unitId) {
    t2 = () => trigger({
      newValue: false,
      courseId,
      moduleId,
      unitId,
      blockIdentifier,
      jwt
    });
    $[2] = blockIdentifier;
    $[3] = courseId;
    $[4] = jwt;
    $[5] = moduleId;
    $[6] = trigger;
    $[7] = unitId;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Button.Icon icon={faX} />;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t) {
    t4 = t("bookmarks.removeBookmark");
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <Button.Label>{t4}</Button.Label>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== isMutating || $[15] !== t2 || $[16] !== t5) {
    t6 = <Button variant="ghost" disabled={isMutating} onClick={t2}>{t3}{t5}</Button>;
    $[14] = isMutating;
    $[15] = t2;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
export default BookmarkRemovalButton;